<template>
  <div
    class="card add-widget grid-stack-item"
    :data-gs-width="width"
    :data-gs-height="height"
    data-gs-no-resize="true"
    :data-event-data="eventData"
    :data-event-name="event"
    :type="type"
  >
    <div>
      <span class="grid-stack-item__move">
        <icon
          name="arrows"
          color="#32325d"
          scale="0.8"
        />
      </span>
    </div>
    <h3 class="add-widget__name grid-stack-item-content">
      {{title}}
    </h3>
  </div>
</template>

<script>
  export default {
    name: "Widget",
    props: ['title', 'eventData', 'event', 'width', 'height', 'type'],
    mounted() {
      $(this.$el).draggable({
        revert: 'invalid',
        handle: '.grid-stack-item__move',
        scroll: false,
        appendTo: 'body',
        helper: 'clone',
      })
    }
  }
</script>

<style scoped lang="scss">
  .add-widget {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90px;
    min-width: 180px;
    margin-bottom: 20px;
    background-color: #fff;
    border-radius: 5px;
    user-select: none;
    .grid-stack-item__move {
      position: absolute;
      top: 0;
      left: -85px;
      width: 200px;
      fill: #32325d;
    }
    &__name {
      display: flex;
      align-items: center;
    }
  }
</style>
